// // src/pages/treatments/CardiacSurgeryPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const CARDIAC_TREATMENT = {
//   slug: "cardiac-surgery",
//   name: "Cardiac Surgery",
//   shortName: "Heart Surgery",
//   tagline: "Protect the Heart That Powers You",
//   heroSubtag: "Save 70–80% on heart surgery. World-class cardiac centres. No waiting list.",
//   description:
//     "Comprehensive cardiac care from bypass surgery to valve repair, delivered by India's leading heart surgeons using the latest minimally invasive and robotic techniques. Our centres perform over 3,000 open-heart procedures annually with outcomes that match global benchmarks.",
//  heroImage:"/PeditricCardiology.jpeg",
//   category: "Cardiology",
//   badge: "Life-Saving",
//   accentColor: "red",
//   costCard: {
//     label: "Complete cardiac package",
//     value: "₹2.5L–₹4.5L",
//     compare: "vs. ₹45L+ in the UK",
//     stay: "10–14 days hospital + 14–21 days recovery",
//     stayCompare: "vs. $40,000–$80,000 in the US",
//   },
//   stats: [
//     { label: "Success Rate", value: "97%", icon: Award },
//     { label: "Surgeries/Year", value: "3,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "ICU Recovery", value: "2-4 Days", icon: Clock },
//   ],
//   benefits: [
//     "Minimally invasive & robotic cardiac surgery options",
//     "Full spectrum: CABG, valve repair/replacement, ASD/VSD closure",
//     "24/7 cardiac catheterisation lab for emergencies",
//     "Dedicated cardiac ICU with 1:1 nurse-to-patient ratio",
//     "Integrated rehabilitation & cardiac physiotherapy",
//     "Insurance pre-authorisation support",
//     "Internationally accredited heart failure programme",
//     "Telemedicine follow-up for outstation patients",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Cardiac Evaluation",
//       desc: "ECG, echocardiography, coronary angiography and risk stratification.",
//       duration: "1-2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Op Optimisation",
//       desc: "Cardiology clearance, blood thinners review, anaesthesia assessment.",
//       duration: "3-5 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Surgery",
//       desc: "CABG, valve or structural procedure under cardiopulmonary bypass or off-pump.",
//       duration: "3-6 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Cardiac Rehab",
//       desc: "Supervised exercise, diet counselling and medication optimisation.",
//       duration: "6-12 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What is bypass surgery (CABG)?",
//       a: "Coronary Artery Bypass Grafting creates new routes for blood to flow around blocked arteries using vessels harvested from your leg, arm or chest wall.",
//     },
//     {
//       q: "How long is the hospital stay after open-heart surgery?",
//       a: "Most patients spend 2-4 days in the cardiac ICU followed by 4-6 days in a step-down ward — typically 7-10 days total.",
//     },
//     {
//       q: "Is robotic cardiac surgery safe?",
//       a: "Yes. Robotic-assisted procedures reduce blood loss, infection risk and recovery time while offering surgeons enhanced precision.",
//     },
//     {
//       q: "When can I return to work?",
//       a: "Desk workers usually return in 6-8 weeks; physically demanding jobs may require 3-4 months. Your surgeon will tailor the timeline.",
//     },
//     {
//       q: "Does insurance cover cardiac surgery?",
//       a: "Most group health policies and Ayushman Bharat cover cardiac procedures. Our insurance team assists with pre-authorisation and cashless claims.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Naresh Trehan",
//       specialty: "Cardiothoracic & Vascular Surgeon",
//       experience: "40 Years",
//       rating: 5.0,
//       reviews: 3800,
//       image: "https://randomuser.me/api/portraits/men/11.jpg",
//       qualifications: "MBBS, MS, FACC, FRCS (UK)",
//       hospital: "Medanta – The Medicity, Gurugram",
//     },
//     {
//       name: "Dr. Devi Prasad Shetty",
//       specialty: "Cardiac Surgeon",
//       experience: "35 Years",
//       rating: 4.9,
//       reviews: 4200,
//       image: "https://randomuser.me/api/portraits/men/21.jpg",
//       qualifications: "MBBS, FRCS (Glasg), FAMS",
//       hospital: "Narayana Health, Bengaluru",
//     },
//     {
//       name: "Dr. Meena Varma",
//       specialty: "Interventional Cardiologist",
//       experience: "22 Years",
//       rating: 4.8,
//       reviews: 1760,
//       image: "https://randomuser.me/api/portraits/women/31.jpg",
//       qualifications: "MBBS, MD (Cardiology), DM",
//       hospital: "Fortis Escorts, Delhi",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Suresh Nair",
//       age: 58,
//       location: "Kochi",
//       text: "Triple bypass and I was walking in the corridor on day three. The cardiac team's precision and the ICU nursing staff's care were extraordinary.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       treatment: "Triple CABG",
//       date: "April 2024",
//     },
//     {
//       name: "Kavita Singh",
//       age: 52,
//       location: "Lucknow",
//       text: "Mitral valve repair done robotically — no big scar, home in eight days. My cardiologist in Lucknow couldn't believe how quickly I recovered.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/52.jpg",
//       treatment: "Robotic Mitral Valve Repair",
//       date: "February 2024",
//     },
//     {
//       name: "Rajiv Kapoor",
//       age: 63,
//       location: "Chandigarh",
//       text: "From diagnosis to surgery in five days. The insurance team handled everything cashless. I only had to focus on getting better.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/48.jpg",
//       treatment: "Aortic Valve Replacement",
//       date: "March 2024",
//     },
//   ],
// };

// const CARDIAC_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African Patients Choose India",
//   whyIndiaReasons: [
//     "India's cardiac success rates: 97–99% for CABG at top-tier hospitals",
//     "No waiting lists — surgery within 7–14 days of arrival",
//     "Surgeons trained at Cleveland Clinic, Mayo Clinic, and UK NHS",
//     "Apollo, Fortis, Medanta, Max — all NABH and JCI accredited",
//   ],
//   conditionsTitle: "Cardiac Surgery Conditions We Facilitate",
//   conditions: [
//     "Coronary Artery Bypass Graft (CABG)",
//     "Heart Valve Replacement / Repair",
//     "Angioplasty & Stenting",
//     "Pacemaker Implantation",
//     "Atrial Septal Defect (ASD) Repair",
//     "Congenital Heart Disease Surgery",
//      "Paediatric Cardiology"
//   ],
//   stayValue: "10–14 days hospital + 14–21 days recovery",
//   costTitle: "Why India for Cardiac Surgery?",
//   costRows: [
//     {
//       procedure: "CABG (Heart Bypass)",
//       india: "₹2.5L – ₹3.8L",
//       africa: "$18,000–$25,000",
//       ukusa: "$40,000–$80,000",
//     },
//     {
//       procedure: "Heart Valve Replacement",
//       india: "₹2.8L – ₹4.2L",
//       africa: "$20,000–$28,000",
//       ukusa: "$50,000–$100,000",
//     },
//     {
//       procedure: "Angioplasty / Stenting",
//       india: "₹1.2L – ₹2.5L",
//       africa: "$10,000–$18,000",
//       ukusa: "$25,000–$50,000",
//     },
//   ],
// };

// const CardiacSurgeryPage = () => {
//   return <TreatmentTemplate treatment={CARDIAC_TREATMENT} paxgrowData={CARDIAC_PAXGROW} />;
// };

// export default CardiacSurgeryPage;


// src/pages/treatments/CardiacSurgeryPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const CARDIAC_TREATMENT = {
  slug: "cardiac-surgery",
  name: "Cardiac Surgery",
  shortName: "Heart Surgery",
  tagline: "Protect the Heart That Powers You",
  heroSubtag: "Save 70–80% on heart surgery. World-class cardiac centres. No waiting list.",
  description:
    "Comprehensive cardiac care from bypass surgery to valve repair, delivered by India's leading heart surgeons using the latest minimally invasive and robotic techniques. Our centres perform over 3,000 open-heart procedures annually with outcomes that match global benchmarks.",
  heroImage: "/PeditricCardiology.jpeg",
  category: "Cardiology",
  badge: "Life-Saving",
  accentColor: "red",
  costCard: {
    label: "Complete cardiac package",
    value: "$3,000–$5,500",
    compare: "vs. $55,000+ in the UK",
    stay: "10–14 days hospital + 14–21 days recovery",
    stayCompare: "vs. $40,000–$80,000 in the US",
  },
  stats: [
    { label: "Success Rate", value: "97%", icon: Award },
    { label: "Surgeries/Year", value: "3,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "ICU Recovery", value: "2-4 Days", icon: Clock },
  ],
  benefits: [
    "Minimally invasive & robotic cardiac surgery options",
    "Full spectrum: CABG, valve repair/replacement, ASD/VSD closure",
    "24/7 cardiac catheterisation lab for emergencies",
    "Dedicated cardiac ICU with 1:1 nurse-to-patient ratio",
    "Integrated rehabilitation & cardiac physiotherapy",
    "Insurance pre-authorisation support",
    "Internationally accredited heart failure programme",
    "Telemedicine follow-up for outstation patients",
  ],
  procedure: [
    {
      step: "01",
      title: "Cardiac Evaluation",
      desc: "ECG, echocardiography, coronary angiography and risk stratification.",
      duration: "1-2 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Op Optimisation",
      desc: "Cardiology clearance, blood thinners review, anaesthesia assessment.",
      duration: "3-5 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Surgery",
      desc: "CABG, valve or structural procedure under cardiopulmonary bypass or off-pump.",
      duration: "3-6 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Cardiac Rehab",
      desc: "Supervised exercise, diet counselling and medication optimisation.",
      duration: "6-12 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What is bypass surgery (CABG)?",
      a: "Coronary Artery Bypass Grafting creates new routes for blood to flow around blocked arteries using vessels harvested from your leg, arm or chest wall.",
    },
    {
      q: "How long is the hospital stay after open-heart surgery?",
      a: "Most patients spend 2-4 days in the cardiac ICU followed by 4-6 days in a step-down ward — typically 7-10 days total.",
    },
    {
      q: "Is robotic cardiac surgery safe?",
      a: "Yes. Robotic-assisted procedures reduce blood loss, infection risk and recovery time while offering surgeons enhanced precision.",
    },
    {
      q: "When can I return to work?",
      a: "Desk workers usually return in 6-8 weeks; physically demanding jobs may require 3-4 months. Your surgeon will tailor the timeline.",
    },
    {
      q: "Does insurance cover cardiac surgery?",
      a: "Most group health policies and Ayushman Bharat cover cardiac procedures. Our insurance team assists with pre-authorisation and cashless claims.",
    },
  ],
  doctors: [
    {
      name: "Dr. Naresh Trehan",
      specialty: "Cardiothoracic & Vascular Surgeon",
      experience: "40 Years",
      rating: 5.0,
      reviews: 3800,
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      qualifications: "MBBS, MS, FACC, FRCS (UK)",
      hospital: "Medanta – The Medicity, Gurugram",
    },
    {
      name: "Dr. Devi Prasad Shetty",
      specialty: "Cardiac Surgeon",
      experience: "35 Years",
      rating: 4.9,
      reviews: 4200,
      image: "https://randomuser.me/api/portraits/men/21.jpg",
      qualifications: "MBBS, FRCS (Glasg), FAMS",
      hospital: "Narayana Health, Bengaluru",
    },
    {
      name: "Dr. Meena Varma",
      specialty: "Interventional Cardiologist",
      experience: "22 Years",
      rating: 4.8,
      reviews: 1760,
      image: "https://randomuser.me/api/portraits/women/31.jpg",
      qualifications: "MBBS, MD (Cardiology), DM",
      hospital: "Fortis Escorts, Delhi",
    },
  ],
  testimonials: [
    {
      name: "Suresh Nair",
      age: 58,
      location: "Kochi",
      text: "Triple bypass and I was walking in the corridor on day three. The cardiac team's precision and the ICU nursing staff's care were extraordinary.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      treatment: "Triple CABG",
      date: "April 2024",
    },
    {
      name: "Kavita Singh",
      age: 52,
      location: "Lucknow",
      text: "Mitral valve repair done robotically — no big scar, home in eight days. My cardiologist in Lucknow couldn't believe how quickly I recovered.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/52.jpg",
      treatment: "Robotic Mitral Valve Repair",
      date: "February 2024",
    },
    {
      name: "Rajiv Kapoor",
      age: 63,
      location: "Chandigarh",
      text: "From diagnosis to surgery in five days. The insurance team handled everything cashless. I only had to focus on getting better.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/48.jpg",
      treatment: "Aortic Valve Replacement",
      date: "March 2024",
    },
  ],
};

const CARDIAC_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African Patients Choose India",
  whyIndiaReasons: [
    "India's cardiac success rates: 97–99% for CABG at top-tier hospitals",
    "No waiting lists — surgery within 7–14 days of arrival",
    "Surgeons trained at Cleveland Clinic, Mayo Clinic, and UK NHS",
    "Apollo, Fortis, Medanta, Max — all NABH and JCI accredited",
  ],
  conditionsTitle: "Cardiac Surgery Conditions We Facilitate",
  conditions: [
    "Coronary Artery Bypass Graft (CABG)",
    "Heart Valve Replacement / Repair",
    "Angioplasty & Stenting",
    "Pacemaker Implantation",
    "Atrial Septal Defect (ASD) Repair",
    "Congenital Heart Disease Surgery",
    "Paediatric Cardiology",
  ],
  stayValue: "10–14 days hospital + 14–21 days recovery",
  costTitle: "Why India for Cardiac Surgery?",
  costRows: [
    {
      procedure: "CABG (Heart Bypass)",
      india: "$3,000–$4,600",
      africa: "$18,000–$25,000",
      ukusa: "$40,000–$80,000",
    },
    {
      procedure: "Heart Valve Replacement",
      india: "$3,400–$5,100",
      africa: "$20,000–$28,000",
      ukusa: "$50,000–$100,000",
    },
    {
      procedure: "Angioplasty / Stenting",
      india: "$1,450–$3,000",
      africa: "$10,000–$18,000",
      ukusa: "$25,000–$50,000",
    },
  ],
};

const CardiacSurgeryPage = () => {
  return <TreatmentTemplate treatment={CARDIAC_TREATMENT} paxgrowData={CARDIAC_PAXGROW} />;
};

export default CardiacSurgeryPage;